/**
 * @generated SignedSource<<743bd027d36e042f6af13a41858c2fce>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ForumOwnerKind = "BLOG" | "COMPETITION" | "DATASET" | "EVENT" | "TOP_LEVEL" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type routingFragment$data = {
  readonly forumOwnerKind: ForumOwnerKind;
  readonly " $fragmentType": "routingFragment";
};
export type routingFragment$key = {
  readonly " $data"?: routingFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"routingFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "routingFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forumOwnerKind",
      "storageKey": null
    }
  ],
  "type": "ForumOwner",
  "abstractKey": "__isForumOwner"
};

(node as any).hash = "2baa696c11b5a8944ac37bbee8350af7";

export default node;
